<div class="full-width">
    <mat-form-field class="medium-width space-after">
        <mat-label>Date</mat-label>
        <input matInput type="date" [(ngModel)]="date" (change)="onChange()" id="dateInput{{idSuffix}}" [required]="required">
        <mat-hint>{{hint}}</mat-hint>
    </mat-form-field>
    <mat-form-field class="narrow-width space-after">
        <mat-label>Hrs</mat-label>
        <mat-select matNativeControl [(ngModel)]="displayHour" [disabled]="!date"  (selectionChange)="onChange()" id="hourSelect{{idSuffix}}" [required]="required">
            <mat-option value="1">1</mat-option>
            <mat-option value="2">2</mat-option>
            <mat-option value="3">3</mat-option>
            <mat-option value="4">4</mat-option>
            <mat-option value="5">5</mat-option>
            <mat-option value="6">6</mat-option>
            <mat-option value="7">7</mat-option>
            <mat-option value="8">8</mat-option>
            <mat-option value="9">9</mat-option>
            <mat-option value="10">10</mat-option>
            <mat-option value="11">11</mat-option>
            <mat-option value="12">12</mat-option>
        </mat-select>
    </mat-form-field>
    <span>:</span>
    <mat-form-field class="narrow-width space-after">
        <mat-label>Min</mat-label>
        <mat-select matNativeControl [(ngModel)]="displayMinutes" [disabled]="!date || !displayHour" (selectionChange)="onChange()" id="minutesSelect{{idSuffix}}" [required]="required">
            <mat-option value="0">00</mat-option>
            <mat-option value="15">15</mat-option>
            <mat-option value="30">30</mat-option>
            <mat-option value="45">45</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="narrow-width space-after">
        <mat-select matNativeControl [(ngModel)]="amOrPm" [disabled]="!date || !displayHour || !displayMinutes" (selectionChange)="onChange()" id="amOrPmSelect{{idSuffix}}" [required]="required">
            <mat-option value="AM">AM</mat-option>
            <mat-option value="PM">PM</mat-option>
        </mat-select>
    </mat-form-field>
    <button *ngIf="endDate" aria-label="Clear end date" class="narrow-width" id="clear" (click)="clear()" mat-icon-button>
        <mat-icon>clear</mat-icon>
    </button>
</div>
